import { requestJSON } from '@/lib/api/api';
import type { VersionResult } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const appVersionKeys = {
  all: ['version'] as const,
};

export function useAppVersion(enabled = true) {
  return useQuery({
    queryKey: appVersionKeys.all,
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: () => requestJSON<VersionResult>('/version'),
  });
}
